/* @ngInject */
export const FileDocumentFactory = () => {
    return function FileDocument() {

        this.id = null;
        this.url = null;
        this.description = null;
    };
};
